import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

/**
 * Hook for fetching active categories for the public frontend
 */
export const useCategorias = () => {
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategorias = async () => {
      try {
        setLoading(true);
        const { data, error } = await supabase
          .from('categorias')
          .select('id, nomCategoria, activo')
          .eq('activo', true)
          .order('nomCategoria', { ascending: true });

        if (error) throw error;
        setCategorias(data || []);
      } catch (err) {
        console.error('Error fetching categorias:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCategorias();
  }, []);

  return { categorias, loading, error };
};
